import { request } from "../base";

type SyncResult = {
	date: string;
	pros: number;
	projects: number;
};

export const adminAnalyticsApi = {
	triggerSync(date?: string) {
		const params = date ? `?date=${date}` : "";
		return request<SyncResult>(`/api/admin/analytics/sync${params}`, {
			method: "POST",
		});
	},
};
